var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"ProductPushCom"},[_c('a',{attrs:{"href":_vm.pushComObj.pushComUrl}},[_c('img',{staticClass:"ProductPushCom-image lazyload",attrs:{"data-src":_vm.pushComObj.pushCom}})])])}
var staticRenderFns = []

export { render, staticRenderFns }